<template>
  <b-form-input
    :value="formattedValue"
    @input="onInput"
    :placeholder="placeholder"
    :state="state"
    :id="id"
    :disabled="disabled"
    :class="inputClass"
    type="text"
  />
</template>

<script>
export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    state: {
      type: Boolean,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: [String, Object, Array],
      default: '',
    },
  },
  computed: {
    formattedValue() {
      if (
        this.value === null ||
        this.value === '' ||
        this.value === undefined
      ) {
        return ''
      }
      const number = this.value.toString().replace(/\D/g, '')
      if (number === '') return ''
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        maximumFractionDigits: 0,
      }).format(number)
    },
  },
  methods: {
    onInput(val) {
      if (!val) {
        this.$emit('input', null)
        return
      }
      // Remove any character that is not a digit
      const number = val.replace(/\D/g, '')
      if (number === '') {
        this.$emit('input', null)
      } else {
        this.$emit('input', Number(number))
      }
    },
  },
}
</script>
